import { render, staticRenderFns } from "./emaillogin.vue?vue&type=template&id=78cf1a12&scoped=true"
import script from "./emaillogin.vue?vue&type=script&lang=js"
export * from "./emaillogin.vue?vue&type=script&lang=js"
import style0 from "./emaillogin.vue?vue&type=style&index=0&id=78cf1a12&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cf1a12",
  null
  
)

export default component.exports